module.exports = __webpack_public_path__ + "img/eyebrow_female_arched_thin.b3bdff48.png";